import { render, staticRenderFns } from "./asset-details.vue?vue&type=template&id=11286137&scoped=true&"
import script from "./asset-details.vue?vue&type=script&lang=js&"
export * from "./asset-details.vue?vue&type=script&lang=js&"
import style0 from "./asset-details.vue?vue&type=style&index=0&id=11286137&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11286137",
  null
  
)

export default component.exports